import { getStore } from '~/mobx/AppStore';

const getIsLoading = (): boolean => {
    const { adminReportStore } = getStore();
    return adminReportStore.isLoadingUserVoteCounts;
};

export default getIsLoading;
